import MultiShopSelectStore from "@/components/MultiShopSelect/MultiShopSelectStore";
import { MultiShopSelectPlatformType } from "@/components/MultiShopSelect/types";
import ShopType from "@/enum/ShopType";

export const otherDropShippingSupplierPlatformTypes = [
    MultiShopSelectPlatformType.other_drop_shipping_supplier_ks,
    MultiShopSelectPlatformType.other_drop_shipping_supplier_xhs,
    MultiShopSelectPlatformType.other_drop_shipping_supplier_channel_shop,
    MultiShopSelectPlatformType.other_drop_shipping_supplier_wb,
    MultiShopSelectPlatformType.other_drop_shipping_supplier_other,
];

export function isOtherDropShippingSupplierPlatform(platform: MultiShopSelectPlatformType) {
    return otherDropShippingSupplierPlatformTypes.includes(platform);
}

export function transformOtherDropShippingSupplierSourceShopType2PlatformType(sourceShopType?: ShopType) {
    if (sourceShopType && MultiShopSelectStore.ksShopTypes.includes(sourceShopType)) {
        return MultiShopSelectPlatformType.other_drop_shipping_supplier_ks;
    }

    if (sourceShopType && MultiShopSelectStore.xhsShopTypes.includes(sourceShopType)) {
        return MultiShopSelectPlatformType.other_drop_shipping_supplier_xhs;
    }

    if (sourceShopType && MultiShopSelectStore.channelShopTypes.includes(sourceShopType)) {
        return MultiShopSelectPlatformType.other_drop_shipping_supplier_channel_shop;
    }

    if (sourceShopType && MultiShopSelectStore.wbShopTypes.includes(sourceShopType)) {
        return MultiShopSelectPlatformType.other_drop_shipping_supplier_wb;
    }

    return MultiShopSelectPlatformType.other_drop_shipping_supplier_other;
}

export function isSupportedOtherDropShippingSupplierSourceShopType(sourceShopType?: ShopType) {
    return (
        !!sourceShopType &&
        (MultiShopSelectStore.ksShopTypes.includes(sourceShopType) ||
            MultiShopSelectStore.xhsShopTypes.includes(sourceShopType) ||
            MultiShopSelectStore.channelShopTypes.includes(sourceShopType) ||
            MultiShopSelectStore.wbShopTypes.includes(sourceShopType))
    );
}
